import React, { useEffect, useState } from "react";
import Layout from "../../layout";
import { Box, Alert, AlertIcon, Text, IconButton } from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { fetchNotificationRequest } from "./store/actions";
import noDataImage from "../../assets/images/NotificationBg.svg";
import ReactDataTable from "../../components/PrimaryTable";

const Notifications = () => {
  const dispatch = useDispatch();

  const { notifications } = useSelector((state) => state.notification);

  useEffect(() => {
    const payload = {};
    // dispatch(resetTrdetails());
    dispatch(fetchNotificationRequest(payload));
  }, [dispatch]);

  const handleViewClick = (id) => {
    let payload = {
      tr_id: id,
    };
    // setSelectedPatient(id);
    // dispatch(fetchTrDetailsRequest(payload));
  };

  const NoDataComponent = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        fontSize: "20px",
      }}
    >
      <img src={noDataImage} alt="No records" style={{ maxWidth: "30%" }} />
      <Text as="b">No notifications yet</Text>
      <Text>When you get notifications, they'll show up here</Text>
    </div>
  );

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: true,
    },

    {
      name: "TR-ID",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            // cursor: "pointer"
          }}
          // onClick={() => handleViewClick(row.tr_id)}
        >
          {row.read === 0 ? (
            <div
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: "#57ACFF",
                marginRight: 8,
              }}
            />
          ) : (
            ""
          )}
          {row.tr_id}
        </div>
      ),
      sortable: true,
    },

    {
      name: "Action Description",
      selector: (row) => row.stage,
      sortable: true,
    },
    {
      name: "Time",
      selector: (row) => row.date_timeago,
      sortable: true,
    },
  ];

  return (
    <Layout header={"Notifications"} iconUrl="/home">
      <Box
        minHeight="600px"
        bgColor={"#ffff"}
        mt="20px"
        ml="10px"
        shadow="md"
        borderWidth="1px"
        borderRadius="md"
      >
        <ReactDataTable
          screen="Notifications"
          columns={columns}
          data={notifications || []}
          noDataComponent={<NoDataComponent />}
          conditionalRowStyles={[
            {
              when: (row) => row.read === 0,
              style: {
                fontWeight: "bold",
              },
            },
            {
              when: (row) => !row.read === 1,
              style: {
                backgroundColor: "#F0F0F0",
              },
            },
          ]}
        />
      </Box>
    </Layout>
  );
};

export default Notifications;
